import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  FloatingLabel,
  Card
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaUser, FaHospital, FaEye, FaEyeSlash } from "react-icons/fa";
import { validateEmail } from "../../utils/validations";
import { UsersService } from "../../services/Users.js";
import { HospitalService } from "../../services/HospitalService.js";
import AlertModal from "../../components/AlertModal";
import "./Login.css";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState("admin");
  const [form, setForm] = useState({
    email: "",
    password: "",
    confirmPassword: ""
  });
  const [error, setError] = useState({
    email: "",
    password: "",
    confirmPassword: ""
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({ title: "", message: "", variant: "info" });

  const isValid = () => {
    let temp = { email: "", password: "", confirmPassword: "" };
    let flag = true;
    
    // Make email mandatory
    if (!form.email) {
      temp.email = "Email is required";
      flag = false;
    } else if (!validateEmail(form.email)) {
      temp.email = "Please enter a valid email address";
      flag = false;
    }
    
    // Make password mandatory
    if (!form.password) {
      temp.password = "Password is required";
      flag = false;
    }
    
    // Make confirm password mandatory
    if (!form.confirmPassword) {
      temp.confirmPassword = "Confirm password is required";
      flag = false;
    } else if (form.password !== form.confirmPassword) {
      temp.confirmPassword = "Passwords do not match";
      flag = false;
    }
    
    setError(temp);
    return flag;
  };

  const onChangePassword = async () => {
    if (isValid()) {
      setLoading(true);
  
      try {
        let response;

        const passwordData = {
          email: form.email,
          password: form.password,
        };
  
        if (userType === "admin") {
          response = await UsersService.updateUsersPassword(passwordData);
        } else if (userType === "hospital") {
          console.log("hospital")
          response = await HospitalService.updateHospitalPassword(passwordData);
        }
  
        // ✅ Clear form
        setForm({
          email: "",
          password: "",
          confirmPassword: "",
        });
  
        // ✅ Handle success message safely
        const successMessage =
          response?.data?.message ||
          response?.message ||
          "Password changed successfully!";
  
        setAlertConfig({
          title: "Password Changed",
          message: successMessage,
          variant: "success", // ✅ use success
        });
        setShowAlert(true);
      } catch (error) {
        console.error("Change password error:", error);

  if (error.response) {
    console.error("Response status:", error.response.status);
    console.error("Response data:", error.response.data);
  } else if (error.request) {
    console.error("No response received. Request was:", error.request);
  } else {
    console.error("Error message:", error.message);
  }

  const errorMessage =
    error.response?.data?.message ||
    error.message ||
    "An error occurred while changing password.";

  setAlertConfig({
    title: "Password Change Failed",
    message: errorMessage,
    variant: "danger",
  });
  setShowAlert(true);
      } finally {
        setLoading(false);
      }
    }
  };
  
  const handleAlertClose = () => {
    setShowAlert(false);
    if (alertConfig.variant === "success") {
      navigate("/login"); // ✅ only redirect on success
    }
  };
  

  return (
    <Container fluid className="bg-light min-vh-100 p-0">
      <Row className="g-0 min-vh-100">
        {/* Right Side - Change Password Form */}
        <Col md={{ span: 5, offset: 3 }} className="d-flex align-items-center justify-content-center p-4" style={{ minHeight: '100vh' }}>
          <div 
            className="bg-white p-4 p-md-5 rounded-3 shadow-sm w-100"
            style={{
              maxWidth: '500px',
              border: '1px solid rgba(0, 0, 0, 0.1)'
            }}
          >
            <div className="text-center mb-4">
              <h2 className="fw-bold mb-3" style={{ color: '#2c3e50', fontSize: '2rem', letterSpacing: '0.5px', position: 'relative', display: 'inline-block', paddingBottom: '0.5rem' }}>
                Change Password
                <span style={{ content: '""', position: 'absolute', bottom: '0', left: '50%', transform: 'translateX(-50%)', width: '60px', height: '3px', backgroundColor: '#0d6efd', borderRadius: '2px' }}></span>
              </h2>
            </div>
            {/* User Type Selection */}
            <div className="d-flex justify-content-center mb-4">
              <div 
                className={`d-flex flex-column align-items-center p-3 mx-2 border rounded-3 cursor-pointer ${userType === 'admin' ? 'border-primary shadow-sm' : 'border-light shadow-sm'}`}
                style={{
                  width: '120px',
                  transition: 'all 0.3s ease-in-out',
                  backgroundColor: userType === 'admin' ? '#f8f9fa' : 'white',
                  boxShadow: userType === 'admin' 
                    ? '0 0.125rem 0.25rem rgba(13, 110, 253, 0.3)' 
                    : '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)'
                }}
                onClick={() => setUserType('admin')}
              >
                <FaUser size={24} className="mb-2" style={{ color: userType === 'admin' ? '#0d6efd' : '#6c757d' }} />
                <span className={userType === 'admin' ? 'text-primary fw-bold' : 'text-muted'} style={{ textAlign: 'center' }}>Admin</span>
              </div>
              <div 
                className={`d-flex flex-column align-items-center p-3 mx-2 border rounded-3 cursor-pointer text-center ${userType === 'hospital' ? 'border-primary shadow-sm' : 'border-light shadow-sm'}`}
                style={{
                  width: '120px',
                  transition: 'all 0.3s ease-in-out',
                  backgroundColor: userType === 'hospital' ? '#f8f9fa' : 'white',
                  boxShadow: userType === 'hospital' 
                    ? '0 0.125rem 0.25rem rgba(13, 110, 253, 0.3)' 
                    : '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)'
                }}
                onClick={() => setUserType('hospital')}
              >
                <FaHospital size={24} className="mb-2" style={{ color: userType === 'hospital' ? '#0d6efd' : '#6c757d' }} />
                <span className={userType === 'hospital' ? 'text-primary fw-bold' : 'text-muted'} style={{ textAlign: 'center' }}>Hospital</span>
              </div>
            </div>
            <Form>
              <FloatingLabel label="Email" className="my-3">
                <Form.Control
                  name="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  type="email"
                  isInvalid={!!error.email}
                  placeholder="Email"
                />
                {error.email && (
                  <p className="required-field-meassage">{error.email}</p>
                )}
              </FloatingLabel>
              <FloatingLabel label="Password" className="my-3 position-relative">
                <Form.Control
                  name="password"
                  placeholder="Password"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  type={showPassword ? "text" : "password"}
                  isInvalid={!!error.password}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#6c757d"
                  }}
                >
                  {showPassword ? <FaEyeSlash style={{ color: '#05275a' }} /> : <FaEye style={{ color: '#05275a' }} />}
                </span>
                {error.password && (
                  <p className="required-field-meassage">{error.password}</p>
                )}
              </FloatingLabel>
              <FloatingLabel label="Confirm Password" className="my-3 position-relative">
                <Form.Control
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={form.confirmPassword}
                  onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
                  type={showConfirmPassword ? "text" : "password"}
                  isInvalid={!!error.confirmPassword}
                />
                <span
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#6c757d"
                  }}
                >
                  {showConfirmPassword ? <FaEyeSlash style={{ color: '#05275a' }} /> : <FaEye style={{ color: '#05275a' }} />}
                </span>
                {error.confirmPassword && (
                  <p className="required-field-meassage">{error.confirmPassword}</p>
                )}
              </FloatingLabel>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '8px', marginBottom: '18px' }}>
                <Button
                  className="custom-btn"
                  type="button"
                  onClick={onChangePassword}
                  disabled={loading}
                  style={{ margin: 0 }}
                >
                  {loading ? "Changing Password..." : "Change Password"}
                </Button>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
      
      <AlertModal
        show={showAlert}
        onHide={handleAlertClose}
        title={alertConfig.title}
        message={alertConfig.message}
        variant={alertConfig.variant}
      />
    </Container>
  );
};

export default ChangePassword;
